// Idle / attract screen. Full-bleed, no shell. Cross-fades through a handful
// of venue photographs — the kiosk doubles as a screensaver between sales —
// behind a navy scrim that keeps the wordmark + the pulsing "Touch to start"
// CTA prominent so visitors never miss the call to action.

import { useEffect, useState } from "react";
import { BrandMark } from "../components/BrandMark";
import { Button } from "../components/Button";
import { ChevronUp } from "../components/Illustrations";
import { LanguageToggle } from "../components/LanguageToggle";
import { useLang } from "../i18n/LangContext";
import type { Dispatch } from "./shared";

// Bundled marketing photos from destinovalpo.cl. Order matters — they
// cross-fade in this sequence and loop.
const ATTRACT_MEDIA = [
  "/attract/fachada.jpg",
  "/attract/mapping.jpg",
  "/attract/interior.jpg",
  "/attract/patrimonio.jpg",
  "/attract/fachadas.jpg",
] as const;

const SLIDE_MS = 7000;

export function AttractScreen({ dispatch }: { dispatch: Dispatch }) {
  const { t } = useLang();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % ATTRACT_MEDIA.length);
    }, SLIDE_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="attract attract--media">
      {ATTRACT_MEDIA.map((src, i) => (
        <img
          alt=""
          aria-hidden="true"
          className={
            i === index ? "attract__media attract__media--on" : "attract__media"
          }
          height={1080}
          key={src}
          src={src}
          width={1920}
        />
      ))}
      <div className="attract__scrim" />
      <div className="attract__content">
        <BrandMark onDark size="lg" />
        <h1 className="attract__headline">{t("attractHeadline")}</h1>
        <Button
          className="attract__cta"
          onClick={() => dispatch({ type: "start" })}
          size="xl"
        >
          {t("attractCta")}
        </Button>
        <div className="attract__hint">
          <ChevronUp />
          <span>{t("attractHint")}</span>
        </div>
        <LanguageToggle variant="pills" />
      </div>
    </div>
  );
}
